'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _styling = require('@rexlabs/styling');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _coreDecorators = require('core-decorators');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styleMixins = require('../utils/style-mixins');

var _styleMixins2 = _interopRequireDefault(_styleMixins);

var _customPropTypes = require('../utils/custom-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectOption = (_dec = (0, _styling.styled)((0, _styling.StyleSheet)({
  container: (0, _extends3.default)({}, _styleMixins2.default.clickStyles, {
    width: '100%',
    padding: '0.25em'
  }),
  isActive: { background: 'black', color: 'white' },
  isPassive: (0, _extends3.default)({}, _styleMixins2.default.disabledClickStyles, { color: 'grey' }),
  isSelected: { background: 'grey', color: 'white' }
})), _dec(_class = (0, _coreDecorators.autobind)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SelectOption, _Component);

  function SelectOption() {
    (0, _classCallCheck3.default)(this, SelectOption);
    return (0, _possibleConstructorReturn3.default)(this, (SelectOption.__proto__ || (0, _getPrototypeOf2.default)(SelectOption)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectOption, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref) {
      var prevIsActive = _ref.isActive;
      var _props = this.props,
          isActive = _props.isActive,
          scrollIntoView = _props.scrollIntoView;
      // When the option becomes active, we should scroll to it's position.

      if (isActive && !(prevIsActive === isActive)) {
        scrollIntoView(this.el);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          styles = _props2.styles,
          option = _props2.option,
          pluckLabel = _props2.pluckLabel,
          isActive = _props2.isActive,
          isPassive = _props2.isPassive,
          isSelected = _props2.isSelected;

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, styles('container', {
          isActive: isActive && !isPassive,
          isSelected: isSelected && !isPassive,
          isPassive: isPassive
        }), {
          ref: this.setRef,
          onMouseEnter: isPassive ? this.nullEvent : this.handleMouseEnter,
          onMouseMove: isPassive ? undefined : this.handleMouseMove,
          onMouseDown: isPassive ? this.nullEvent : this.handleMouseDown,
          onTouchStart: isPassive ? undefined : this.handleTouchStart,
          onTouchMove: isPassive ? undefined : this.handleTouchMove,
          onTouchEnd: isPassive ? this.nullEvent : this.handleTouchEnd
        }),
        pluckLabel(option)
      );
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.el = ref;
    }
  }, {
    key: 'handleMouseHover',
    value: function handleMouseHover(event) {
      var _props3 = this.props,
          index = _props3.index,
          option = _props3.option,
          onHover = _props3.onHover;

      onHover(index, option, event);
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(event) {
      this.handleMouseHover(event);
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      this.handleMouseHover(event);
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      var _props4 = this.props,
          option = _props4.option,
          onSelect = _props4.onSelect;

      onSelect(option, event);
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      // When a touch starts from inside an Option, we know the screen *is not*
      // being dragged; we should hand it's end event with an `onSelect`.
      this.isBeingDragged = false;
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      // As soon as the user starts dragging there finger on an Option, we no
      // longer want to action it's end with an `onSelect`.
      this.isBeingDragged = true;
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      if (this.isBeingDragged) return;

      this.handleMouseDown(event);
    }
  }, {
    key: 'nullEvent',
    value: function nullEvent(event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }]);
  return SelectOption;
}(_react.Component), _class2.defaultProps = {
  isPassive: false,
  onHover: _lodash2.default.noop,
  onSelect: _lodash2.default.noop
}, _temp)) || _class) || _class);
process.env.NODE_ENV !== "production" ? SelectOption.propTypes = {
  styles: _propTypes2.default.func,
  /** The active index of the Option */
  index: _propTypes2.default.any,
  /** The data to display. */
  option: _customPropTypes.OptionPropType.isRequired,
  /** The helper for getting the 'label prop' from option. */
  pluckLabel: _propTypes2.default.func.isRequired,
  /** The helper for getting the 'value prop' from option. */
  pluckValue: _propTypes2.default.func,
  /** Whether this Option is actively hovered or reached by up/down. */
  isActive: _propTypes2.default.bool,
  /** Whether this Option is actively hovered or reached by up/down. */
  isPassive: _propTypes2.default.bool,
  /** Whether this Option is actively hovered or reached by up/down. */
  isSelected: _propTypes2.default.bool,
  /** Fires when the mouse/touch hovers over the Option: function (event) */
  onHover: _propTypes2.default.func,
  /** Fires when the Option is clicked or touched: function (event) */
  onSelect: _propTypes2.default.func,
  /** Helper util to call when this Option becomes active: function (element) */
  scrollIntoView: _propTypes2.default.func
} : void 0;
exports.default = SelectOption;